import { signal } from '@angular/core';

export const isProvidersHasPragmatic = signal(false);

export const unreadMessagesCount = signal(-1);
